<template>
  <div
    class="subheader py-2 py-lg-4 subheader-solid"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <div
      class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="d-flex">
        <span v-show="showMobileToggle">
          <button
            class="burger-icon burger-icon-right mr-4 d-inline-block d-lg-none"
            id="kt_subheader_mobile_toggle"
          >
            <span></span>
          </button>
        </span>

        <div class="d-flex align-items-baseline flex-wrap mr-5">
          <h5
            class="text-dark font-weight-bold my-2 mr-5 text-overflow-ellipsis max-w-350px"
          >
            {{ title }}
          </h5>
          <ul
            class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2"
          >
            <li class="breadcrumb-item">
              <router-link :to="'/'" class="subheader-breadcrumbs-home">
                <i class="flaticon2-shelter text-muted icon-1x"></i>
              </router-link>
            </li>

            <template v-for="(breadcrumb, i) in breadcrumbs">
              <li class="breadcrumb-item" :key="`${i}-${breadcrumb.id}`">
                <router-link
                  v-if="breadcrumb.route"
                  :key="i"
                  :to="breadcrumb.route"
                  class="text-muted text-overflow-ellipsis max-w-250px"
                >
                  {{ breadcrumb.title }}
                </router-link>
                <span
                  class="text-muted text-overflow-ellipsis max-w-250px"
                  :key="i"
                  v-if="!breadcrumb.route"
                >
                  {{ breadcrumb.title }}
                </span>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <div v-if="showActionBar" class="d-flex align-items-center">
        <button
          v-for="(action, i) in buttonActions"
          :key="`btn-action-${i}`"
          @click="eventHub.$emit(action.event, $event)"
          class="btn font-weight-bold btn-sm ml-2"
          :class="action.class ? action.class : 'btn-light'"
          :id="action.id"
          v-html="action.name"
        ></button>
        <router-link
          v-for="(action, i) in linkActions"
          :key="`link-action-${i}`"
          :to="action.to"
          class="btn font-weight-bold btn-sm ml-2"
          :class="action.class ? action.class : 'btn-light'"
          :id="action.id"
          v-html="action.name"
        >
        </router-link>
        <button
          @click="eventHub.$emit('re_render_page', this)"
          class="btn btn-light font-weight-bold btn-sm ml-2"
        >
          <i class="flaticon2-refresh p-0"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "buttonActions",
      "linkActions",
      "showActionBar",
      "showMobileToggle"
    ]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    }
  }
};
</script>
